export const GRID_FILTER = "GRID_FILTER";
export const GRID_PAGE_SIZE = "GRID_PAGE_SIZE";
export const GRID_SKIP = "GRID_SKIP";
export const GRID_SORT = "GRID_SORT";
export const GRID_DATASTATE = "GRID_DATASTATE";
export const ADVANCE_ADDITIONALWHERE = "ADVANCE_ADDITIONALWHERE";
export const CHANGED_FIELD = "CHANGED_FIELD";
